import type { TTMSAppSource } from '../../../types/tracking'
import { StatusIcon } from '../status-icon'

interface ITMSAppTrackingInfo {
  trackingSourceData: TTMSAppSource
}

/**
 * The component that displays the TMS App info in a tooltip
 */
export const TMSAppTrackingInfo = (props: ITMSAppTrackingInfo) => {
  const { trackingSourceData } = props

  return (
    <div className="flex w-full flex-col space-y-2 items-start">
      <p className="text-md font-semibold">
        This data is being sent by {trackingSourceData?.sourceDisplayName || 'TMS App'} through API
      </p>

      <div className="flex items-center space-x-2">
        <StatusIcon isPositive={Boolean(trackingSourceData.locations?.length)} />
        <span>Status: {trackingSourceData?.locations?.length ? 'Tracking' : 'Not tracking'}</span>
      </div>
    </div>
  )
}
